import { NavLink, Link } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="nav">
      <div className="container nav__inner">
        <Link to="/" className="brand" onClick={closeMenu}>Stickerei Zschoche</Link>
        <button
          className={`nav__burger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Menü öffnen/schließen"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`nav__links ${isMenuOpen ? "active" : ""}`}>
          <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
          <NavLink to="/produktbeispiele" onClick={closeMenu}>Produktbeispiele</NavLink>
          <NavLink to="/impressum-datenschutz" onClick={closeMenu}>Impressum / Datenschutz</NavLink>
        </div>
      </div>
    </nav>
  );
}

